<!--保障计划-->
<template>
  <div class="comp-insure-plan">
    <!-- 内容区 -->
    <div class="hd-title">
      <span>{{name}}</span>
      <label @click="goToInsurePlanDetail">查看详情<img src="@/assets/images/icon-right-arrow.png"></label>
    </div>
    <div class="hd-cont">
      <ul>
        <li v-for="(item,index) in insureArrangeData" :key="index">
          <span>{{item.title}}</span>
          <label>{{item.value}}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'insurePlan',
  data() {
    return {
      name: '保障计划',
    }
  },
  props: {
    insureArrangeData: {
      type: Array,
      default: () => []
    },
    insuranceId: {
      type: String,
      default: ''
    },
    pageId: {
      type: String,
      default: ''
    } 
  },
  computed: {
    
  },
  methods: {
    goToInsurePlanDetail() {
      this.$router.push({
        name: 'insurancePlan',
        query: {
          insid: this.insuranceId,
          pid: this.pageId
        }
      })
    }
  },
  created() {

  }
}
</script>

<style scoped lang="stylus">
  .comp-insure-plan
    width: 100%
    background-color: #fff
    padding: 0 .3rem .1rem .3rem
    .hd-title
      display: flex
      height: 1.04rem
      align-items: center
      justify-content: space-between
      span
        text-align: left
        font-size: .34rem
        color: #333
        font-weight: 500
      label
        font-size: .28rem
        color: #333
        img
          vertical-align: middle
          height: .23rem
          margin-left: .1rem
          margin-top: -3px
    .hd-cont
      ul
        li
          display: flex
          justify-content: space-between
          align-items: center
          height: .4rem
          margin-bottom: .27rem
          span
            font-size: .28rem;
            color: #333
          label
            font-size: .28rem;
            color: #666
          
</style>






